<app-form-popup
    [width]="640"
    [visible]="visible()"
    [titleText]="dialogTitle()"
    [wrapperAttr]="{ class: 'entity-block-dialog' }"
    [footerButtons]="footerButtons()"
    (clicked)="onFooterClicked($event)"
    (visibleChange)="onVisibleChange($event)"
>
    <div class="entity-block-dialog__content">
        <dx-form
            #form
            class="entity-block-dialog__form plain-styled-form"
            [formData]="formData()"
            [colCount]="1"
            [requiredMark]="'*'"
            [showRequiredMark]="true"
            [showColonAfterLabel]="false"
            (onContentReady)="onFormContentReady($event)"
            (onFieldDataChanged)="onFormFieldDataChanged()"
        >
            <!-- <dxi-form-item
                dataField="entityType"
                editorType="dxTextBox"
                [label]="{ text: ('label_entityType' | transloco) }"
                [editorOptions]="{
                    value: entityTypeLabel(),
                    readOnly: true,
                    stylingMode: 'outlined',
                }"
            ></dxi-form-item> -->
            <dxi-form-item
                dataField="entityName"
                editorType="dxTextBox"
                [label]="{ text: ('label_name' | transloco) }"
                [editorOptions]="{
                    readOnly: true,
                    disabled: true,
                    stylingMode: 'outlined',
                }"
            ></dxi-form-item>
            <dxi-form-item
                dataField="reason"
                editorType="dxSelectBox"
                [isRequired]="true"
                [label]="{ text: ('label_blockReason' | transloco) }"
                [validationRules]="reasonValidationRules"
                [editorOptions]="{
                    items: reasonOptions(),
                    displayExpr: 'text',
                    valueExpr: 'value',
                    searchEnabled: true,
                    showClearButton: true,
                    placeholder: ('placeholder_select_block_reason' | transloco),
                    stylingMode: 'outlined',
                }"
            ></dxi-form-item>
            <dxi-form-item
                dataField="description"
                editorType="dxTextArea"
                [label]="{ text: ('label_description' | transloco) }"
                [editorOptions]="{
                    minHeight: 96,
                    autoResizeEnabled: true,
                    maxLength: descriptionMaxLength,
                    placeholder: ('placeholder_block_description' | transloco),
                    stylingMode: 'outlined',
                }"
            ></dxi-form-item>
        </dx-form>
    </div>
</app-form-popup>
